import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { ProductQualityInstructions } from "../../types"
import { renderCheckMarkIcon } from "../../utils"

import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface AssociatedTestTemplatePostTestNoteSectionsProps {
  productQualityInstructions: ProductQualityInstructions
  onEdit: () => void
}

export const AssociatedTestTemplatePostTestNoteSections: FC<AssociatedTestTemplatePostTestNoteSectionsProps> = ({
  productQualityInstructions,
  onEdit,
}) => {
  const { hasPermissions } = usePermissionManager()
  const isPrintPostTestNotesToAkrochemCoa = Boolean(productQualityInstructions.printPostTestNotesToAkrochemCoa)

  return (
    <Paper
      variant='outlined'
      elevation={0}
      className='flex flex-col gap-y-6 border-gray-300 p-6'
      data-testid='post-test-notes-section'
    >
      <Box className='flex items-center justify-between gap-4'>
        <Typography variant='subtitle1' component='h3' className='text-ml text-gray-900'>
          Post Test Note
        </Typography>
        {hasPermissions([PermissionActionType.TEST_TEMPLATE_MAINTENANCE]) && (
          <IconButton onClick={onEdit} data-testid='edit-post-test-notes-button'>
            <EditOutlined color='primary' />
          </IconButton>
        )}
      </Box>
      <Typography className='font-normal text-gray-900' variant='body2'>
        <Box component='span' data-testid='print-post-test-notes-icon'>
          {renderCheckMarkIcon(isPrintPostTestNotesToAkrochemCoa)}
        </Box>{" "}
        Print Post Test Notes to Akrochem COA
      </Typography>
      {productQualityInstructions.postTestNotes && (
        <Typography className='font-normal text-gray-900' variant='body2' data-testid='post-test-notes'>
          {productQualityInstructions.postTestNotes}
        </Typography>
      )}
    </Paper>
  )
}
